import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { logoutAdmin } from '../services/adminAuth';

function AdminLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogout = () => {
    logoutAdmin();
    navigate('/admin/login');
  };
  
  const isActive = (path) => {
    return location.pathname === path ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white';
  };
  
  return (
    <div className="min-h-screen bg-gray-100">
      <nav className="bg-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <span className="text-white font-bold">Admin Panel</span>
              </div>
              <div className="hidden md:block">
                <div className="ml-10 flex items-baseline space-x-4">
                  <Link
                    to="/admin/dashboard"
                    className={`px-3 py-2 rounded-md text-sm font-medium ${isActive('/admin/dashboard')}`}
                  >
                    Dashboard
                  </Link>
                  <Link
                    to="/admin/articles"
                    className={`px-3 py-2 rounded-md text-sm font-medium ${isActive('/admin/articles')}`}
                  >
                    Articles
                  </Link>
                  <Link
                    to="/admin/feedback"
                    className={`px-3 py-2 rounded-md text-sm font-medium ${isActive('/admin/feedback')}`}
                  >
                    Feedback
                  </Link>
                  <Link
                    to="/admin/newsletter-preview"
                    className={`px-3 py-2 rounded-md text-sm font-medium ${isActive('/admin/newsletter-preview')}`}
                  >
                    Newsletter Preview
                  </Link>
                  <Link
                    to="/admin/user-management"
                    className={`px-3 py-2 rounded-md text-sm font-medium ${isActive('/admin/user-management')}`}
                  >
                    User Management
                  </Link>
                </div>
              </div>
            </div>
            <div>
              <button
                onClick={handleLogout}
                className="px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </nav>

      <main>
        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>
    </div>
  );
}

export default AdminLayout; 